import { createSelector } from 'reselect';
import { createInstanceValueSelector, selectCurrentInstance } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { getTranslatedLanguageName } from '../../utils/lang';
export const selectArticleId = createInstanceValueSelector('hs_id');
export const selectGroupId = createInstanceValueSelector('hs_group_id');
export const selectArticleLanguage = createInstanceValueSelector('hs_language');
export const selectArticleTranslatedFromId = createInstanceValueSelector('hs_translated_from_id');
export const selectArticleSummary = createInstanceValueSelector('hs_summary');
export const selectArticlePath = createInstanceValueSelector('hs_path');
export const selectAccessRuleType = createSelector([selectCurrentInstance], currentInstance => {
  if (currentInstance && currentInstance.values && currentInstance.values['hs_access_rule_type']) {
    return currentInstance.values['hs_access_rule_type'];
  }
  return PublicAccessRuleTypes.PUBLIC;
});
export const selectArticleHeadHtml = createInstanceValueSelector('hs_head_html');
export const selectAccessListIds = createSelector([selectCurrentInstance], currentInstance => {
  if (currentInstance && currentInstance.values && currentInstance.values['hs_access_rule_ids']) {
    return currentInstance.values['hs_access_rule_ids'];
  }
  return [];
});
export const selectArticleTags = createInstanceValueSelector('hs_tag_ids');
export const selectMetaDescription = createInstanceValueSelector('hs_meta_description');
export const selectArticleCategoryId = createInstanceValueSelector('hs_knowledge_category_id');
export const selectArticleTranslations = createSelector([selectCurrentInstance], currentInstance => {
  if (currentInstance) {
    return Object.values(currentInstance.translations);
  }
  return [];
});
export const selectArticleLanguageOptions = createSelector([selectCurrentInstance, selectArticleTranslations], (currentInstance, articleTranslations) => {
  if (currentInstance) {
    const allArticleVariants = [...articleTranslations, currentInstance];
    return allArticleVariants.map(translatedArticle => ({
      text: getTranslatedLanguageName(translatedArticle.values.hs_language),
      language: translatedArticle.values.hs_language,
      value: translatedArticle.values.hs_id
    }));
  }
  return [];
});